import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DataTableHeaderCell from './DataTableHeaderCell';
import PropTypes from 'prop-types';
import DataTableHeaderCellCheckbox from './DataTableHeaderCellCheckbox';

const DataTableHeader = (props) => {
  const {
    columns,
    order = 'asc',
    orderBy,
    setOrder,
    setOrderBy,
    setColumnsFilter,
    columnsFilter = {},
    showCheckbox,
    onFilterOpen,
    setCheckedAll,
    checkedAll,
  } = props;

  const handleOrderClick = (column) => {
    if (orderBy === column) {
      orderSwitcher();
    } else {
      setOrderBy(column);
      setOrder('asc');
    }
  };

  const orderSwitcher = () => {
    if (order === 'asc') {
      setOrder('desc');
    } else {
      setOrder('asc');
    }
  };

  const setCurrentFilter = (columnId, filterData) => {
    setColumnsFilter((prevValue) => {
      const output = { ...prevValue };
      if (filterData.length > 0) {
        output[columnId] = filterData;
      } else if (output[columnId]) {
        delete output[columnId];
      }
      return output;
    });
  };

  return (
    <React.Fragment>
      <colgroup>
        {showCheckbox && <col key={'checkbox'} style={{ width: '*' }} />}
        {columns.map((column) => (
          <col key={column.id} style={{ width: column.width ? column.width : '*' }} />
        ))}
      </colgroup>
      <TableHead>
        <TableRow>
          {showCheckbox && <DataTableHeaderCellCheckbox setCheckedAll={setCheckedAll} checkedAll={checkedAll} />}
          {columns.map((column) => {
            let colWidth = column?.width;
            if (colWidth?.includes('%')) {
              colWidth = null;
            }

            return (
              <DataTableHeaderCell
                key={column.id}
                id={column.id}
                width={colWidth}
                label={column.label}
                options={column.options}
                align={column.align}
                orderBy={orderBy}
                order={order}
                onOrderClick={handleOrderClick}
                setCurrentFilter={(currentFilter) => {
                  setCurrentFilter(column.id, currentFilter);
                }}
                currentFilter={columnsFilter?.[column.id] || []}
                onFilterOpen={onFilterOpen}
              />
            );
          })}
        </TableRow>
      </TableHead>
    </React.Fragment>
  );
};

const columnShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  width: PropTypes.string,
});

DataTableHeader.propTypes = {
  columns: PropTypes.arrayOf(columnShape),
  columnsFilter: PropTypes.object,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  onOrderClick: PropTypes.func,
  checkedAll: PropTypes.bool,
  setOrder: PropTypes.func,
  setOrderBy: PropTypes.func,
  setColumnsFilter: PropTypes.func,
  setCheckedAll: PropTypes.func,
  showCheckbox: PropTypes.bool,
  onFilterOpen: PropTypes.func,
};

export default DataTableHeader;
